import React, {  lazy } from 'react';
import ProfileCard from './ProfileCard';
import ChatBot from './ChatBot';
import VisionBot from './VisionBot';
import LazyLoad from "./LazyLoad";

// Lazy load heavier components
const AgentTiles = lazy(() => import('./AgentTiles'));
const TechStackRadarChart = lazy(() => import('./TechStackRadarChart'));
const ResumeTimeline = lazy(() => import('./ResumeTimeline'));
const SkillsHighlight = lazy(() => import('./SkillsHighlight'));
// const AgentNewsFeed = lazy(() => import('./AgentNewsFeed'));


const AgenticDashboard = () => {
  return (
    <main className="p-8">
      {/* <div className="flex flex-col md:flex-row gap-6"> */}
        <div > {/*className="w-full md:w-1/2"*/ }
          <ProfileCard />
          <ChatBot/>
          <VisionBot/>
        </div>

        {/* <div className="w-full md:w-1/2 flex">
          <LazyLoad>
            <AgentNewsFeed />
          </LazyLoad>
        </div>
      </div> */}
      <div className="mt-10 space-y-8">
        <LazyLoad>
          <ResumeTimeline />
        </LazyLoad>

        <LazyLoad>
          <SkillsHighlight />
        </LazyLoad>

        <LazyLoad>
          <AgentTiles />
        </LazyLoad>

        <LazyLoad>
          <TechStackRadarChart />
        </LazyLoad>
      </div>
    </main>
  );
};




export default AgenticDashboard;
